<template>
  <div class="main-paragraph-container text-content">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "MainParagraph"
}
</script>

<style scoped lang="scss">
  .main-paragraph-container {
    white-space: pre-wrap;
    line-height: 120%;
    font-weight: 400;
    color: var(--color-font-squid);
  }




  @media (max-width: 3024px){
    .main-paragraph-container {
      font-size: 32px;
    }
  }


  @media (max-width: 1920px) {
    .main-paragraph-container {
      font-size: 24px;
    }
  }


  @media (max-width: 1600px) {
    .main-paragraph-container {
      font-size: 18px;
    }
  }
  @media (max-height: 800px) {
    .main-paragraph-container {
      font-size: 16px;
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .main-paragraph-container {
      font-size: 18px;
    }
  }

  @media (max-width: 1133px) {
    .main-paragraph-container {
      font-size: 16px;
    }
  }

  @media (max-width: 769px) {
    .main-paragraph-container {
      font-size: 14px;
    }
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    .main-paragraph-container {
      font-size: 14px;
    }
  }

  @media (min-height: 600px) and (max-height: 630px){

    //8 plus
  }

  @media (max-width: 375px) {
    //se new
  }

  @media (max-width: 375px) and (min-height: 630px) {
    //x
  }


  @media (max-width: 320px) {
    //se old
  }

  @media (min-width: 3025px) {
    .main-paragraph-container {
      font-size: 48px;
    }
  }

</style>